import React from 'react';
import { useParams } from 'react-router-dom';

import { useHomeData } from '../components/LoadHomeData/HomeDataProvider';
import { NoAccessToView } from '../components/NoAccessToView/NoAccessToView';
import { useTranslations } from '../components/Translations/TranslationsProvider';
import { VisitorCardScanResult } from '../components/VisitorCardScanResult/VisitorCardScanResult';

export const VisitorCardScanResultPage = () => {
    const { nonce } = useParams();
    const { translations } = useTranslations();
    const { homepageData } = useHomeData();
    const isGuard = homepageData?.authorizations?.mayUseGuardsMobileFx ?? false;

    return (
        <>
            {!isGuard && <NoAccessToView translations={translations} />}
            {isGuard && <VisitorCardScanResult nonce={nonce} translations={translations} />}
        </>
    );
};
